import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.cookie = `timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}; path=/`
  }
}